export default __webpack_public_path__ + "static/media/stu.4a241af3.png";